import { render } from "./MetodoPagoEfecty.vue?vue&type=template&id=668fec52"
import script from "./MetodoPagoEfecty.vue?vue&type=script&lang=js"
export * from "./MetodoPagoEfecty.vue?vue&type=script&lang=js"

import "./MetodoPagoEfecty.vue?vue&type=style&index=0&id=668fec52&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__